import React, { useCallback, useContext } from "react";
import { GoDotFill } from "react-icons/go";
import { Tooltip } from "antd";
import styles from "../controls.module.css";
import useFlowStatus from "../../../../hooks/useFlowStatus";
import flowContext from "../../../../contexts/flowContext";
import Spinner from "../../../Spinner";

const FlowStatus = () => {
  const [flowState] = useContext(flowContext);
  const { isPublished, isLoading } = useFlowStatus(flowState._id);

  const getIconTitle = useCallback(() => {
    if (flowState.isSynchronizedWithPublishedConfig) {
      return "Flow is synchronized with published config";
    } else if (isPublished) {
      return "Flow is published but not synchronized with published config";
    } else {
      return "Flow is not published";
    }
  }, [isPublished, flowState.isSynchronizedWithPublishedConfig]);

  return (
    <div className={styles.button_container}>
      {isLoading !== undefined && isLoading && (
        <span className={styles.spinner_container}>
          <Spinner spinning={isLoading} />
        </span>
      )}

      {!isLoading && isPublished !== undefined && (
        <Tooltip placement="bottom" title={getIconTitle()}>
          <span className={styles.icon_container}>
            <GoDotFill
              className={`${styles.status_icon} ${
                flowState.isSynchronizedWithPublishedConfig
                  ? styles.is_synchronized
                  : isPublished
                  ? styles.is_published
                  : ""
              }`}
            />
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default FlowStatus;
